import { widgetBusinessFetch } from "./business-fetch";
import { err, ok, type Result } from "neverthrow";
import { z } from "zod";
import {
  supportRequestCardSchema,
  supportRequestFailureSchema,
  type SupportRequestCard,
  type SupportRequestCommand,
  type SupportRequestFailure,
} from "@go-novus/admin-api";

export async function requestSupportDraft(
  handshakeUrl: string,
  input: {
    uid: string;
    conversationId: string;
    liquidCustomerId?: string;
    command: SupportRequestCommand;
  },
  fetchImpl: typeof fetch = widgetBusinessFetch(handshakeUrl),
): Promise<Result<SupportRequestCard, SupportRequestFailure>> {
  try {
    const url = new URL(handshakeUrl, window.location.href);
    url.pathname = url.pathname.replace(/\/handshake$/, "/support-requests");
    const response = await fetchImpl(url.href, {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        uid: input.uid,
        conversation_id: input.conversationId,
        liquid_customer_id: input.liquidCustomerId,
        command: input.command,
      }),
      signal: AbortSignal.timeout(15_000),
    });
    const body: unknown = await response.json();
    if (!response.ok) {
      const failure = supportRequestFailureSchema.safeParse(body);
      return err(
        failure.success
          ? failure.data
          : { error: "upstream_unavailable" as const },
      );
    }
    const parsed = z.object({ card: supportRequestCardSchema }).safeParse(body);
    return parsed.success
      ? ok(parsed.data.card)
      : err({ error: "upstream_unavailable" as const });
  } catch {
    return err({ error: "upstream_unavailable" as const });
  }
}
